import { Block, CRIcon, CRRender } from '@/components/crRender'

const ItemPreviewer = ({item,index,handleRemove,getFileIcon,formatFileSize,t,getFileFormat}) => {
  return (
    <div key={item?.name} className={`file-upload-preview ${getFileFormat(item) === "image" ? "with-image" : ""}`}>
        <CRRender isRender={getFileFormat(item) !== "image"}>
            <div className="file-icon-wrapper">
                <CRIcon icon={getFileIcon(item)} className="file-icon" />
        </div>
        <div className="file-info">
            <div className="file-name">{item?.name?.length > 20 ? item?.name?.substring(0, 20) + '...' : item?.name}</div>
            <Block isRender={!!item?.size} className="file-size">{formatFileSize(item.size)}</Block>
        </div>
        </CRRender>
        <CRRender isRender={getFileFormat(item) === "image"} >
            <img src={URL.createObjectURL(item)} alt={item?.name} className="file-upload-preview-image" />
        </CRRender>
        <button type="button" className="file-remove-btn"
            onClick={(e) => handleRemove(e, item)} title={t("remove")}  >
            <CRIcon icon="mdi:close-circle" />
        </button>
    </div>
  )
}

export default ItemPreviewer
